import { render } from "./TableSupplier_responsibles.vue?vue&type=template&id=b69e0b32&scoped=true"
import script from "./TableSupplier_responsibles.vue?vue&type=script&lang=js"
export * from "./TableSupplier_responsibles.vue?vue&type=script&lang=js"

import "./TableSupplier_responsibles.vue?vue&type=style&index=0&id=b69e0b32&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b69e0b32"]])

export default __exports__